import { create } from "zustand";
import { devtools } from "zustand/middleware";

export type RegeneratePollingOwner = "tab" | "layout";

interface RegeneratePollingState {
  commentId: number | null;
  code: string | null;
  actorName: string;
  owner: RegeneratePollingOwner | null;
  startPolling: (commentId: number, code: string, actorName: string) => void;
  handoffToLayout: () => void;
  stopPolling: () => void;
}

export const useRegeneratePollingStore = create<RegeneratePollingState>()(
  devtools(
    (set) => ({
    commentId: null,
    code: null,
    actorName: "",
    owner: null,

    startPolling: (commentId, code, actorName) =>
      set({ commentId, code, actorName, owner: "tab" }),

    handoffToLayout: () =>
      set((state) =>
        state.commentId != null
          ? { ...state, owner: "layout" as RegeneratePollingOwner }
          : state
      ),

      stopPolling: () =>
        set({
          commentId: null,
          code: null,
          actorName: "",
          owner: null,
        }),
    }),
    { name: "RegeneratePolling" }
  )
);
